export interface CheckoutInsuranceProvider {
  name: string;
  id: string;
  isPopular?: boolean;
  plans?: CheckoutInsurancePlan[];
}

export interface CheckoutInsurancePlan {
  name: string;
  id: string;
  isPopular?: boolean;
}

export interface DateOfBirth {
  day: string;
  month: string;
  year: string;
}

export enum SexAtBirth {
  Male = 'Male',
  Female = 'Female',
}

interface CheckoutAccount {
  email: string | null;
  phone: string | null;
  phoneToSave?: string | null;
  phoneToUpdate?: string | null;
}

interface CheckoutPatient {
  firstName: string;
  lastName: string;
  dateOfBirth: DateOfBirth;
  sexAssignedAtBirth: SexAtBirth | null;
  isReturningPatient?: boolean;
}

interface CheckoutInsurance {
  hasInsurance: boolean | null;
  provider: CheckoutInsuranceProvider | null;
  plan: CheckoutInsurancePlan | null;
  memberId: string;
  groupId: string;
  isPrimaryMember: boolean | null;
  primaryMember: {
    firstName: string;
    lastName: string;
    dateOfBirth: DateOfBirth;
  };
}

export enum PreferredContactMethod {
  Phone = 'phone',
  SMS = 'sms',
}

export interface PreferredContactMethods {
  [PreferredContactMethod.Phone]?: boolean;
  [PreferredContactMethod.SMS]?: boolean;
}

interface CheckoutConfirm {
  preferredContactMethods: PreferredContactMethods;
  note: string;
}

export interface CheckoutState {
  account: CheckoutAccount;
  patient: CheckoutPatient;
  insurance: CheckoutInsurance;
  confirm: CheckoutConfirm;
  timeRemaining: number | null;
}
